import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
import { Lock, ShieldCheck } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 px-4 max-w-4xl mx-auto text-center" data-id="element-22">
      <FadeIn data-id="element-23">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-10" data-id="element-24">
          Ready to stop guessing?
        </h2>
        <div className="flex flex-col items-center" data-id="element-25">
          <a href="https://trackrt.activapleno.com/click" className="inline-block w-full sm:w-auto decoration-transparent mb-6" data-id="element-26">
            <Button size="xl" fullWidth className="sm:w-auto" data-id="element-27">
              Start Now and Save on Your Installation &rarr;
            </Button>
          </a>

          <div className="flex items-center justify-center space-x-4 text-sm text-gray-500 font-medium" data-id="element-28">
            <div className="flex items-center" data-id="element-29">
              <Lock className="w-4 h-4 mr-1.5 text-gray-400" data-id="element-30" />
              Secure
            </div>
            <div className="flex items-center" data-id="element-31">
              <ShieldCheck className="w-4 h-4 mr-1.5 text-green-500" data-id="element-32" />
              No commitment required. Just real prices.
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}